document.addEventListener("DOMContentLoaded", () => {
  // Cart update listener
  document.querySelectorAll('form[action*="/cart"]').forEach((form) => {
    form.addEventListener("submit", (e) => {
      // Prevent default only if you want custom handling
      // e.preventDefault();
    })
  })

  // Global cart drawer: open when clicking header cart icon or after add-to-cart
  window.openCartDrawer = function(){
    // create or reuse panel
    let overlay = document.querySelector('.cart-drawer__overlay');
    let panel = document.querySelector('.cart-drawer__panel');
    if(!overlay){
      overlay = document.createElement('div'); overlay.className = 'cart-drawer__overlay';
      panel = document.createElement('div'); panel.className = 'cart-drawer__panel';
      const container = document.createElement('div'); container.className = 'cart-drawer';
      container.appendChild(overlay); container.appendChild(panel); document.body.appendChild(container);
      overlay.addEventListener('click', () => container.classList.remove('open'));
    }
    // fetch and render cart
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(r => { if(!r.ok) throw r; return r.json(); })
      .then(cart => {
        // reuse renderCart from snippet if available, otherwise inline render here
        if(window.renderCartDrawer){ window.renderCartDrawer(panel, cart); }
        else {
          panel.innerHTML = '<div class="cart-drawer__title">Your cart</div><div class="cart-drawer__item">Items: ' + (cart.item_count||0) +'</div>';
        }
        document.querySelector('.cart-drawer').classList.add('open');
      }).catch(err => console.error('Failed to open cart drawer', err));
  }

  // Expose a simple renderCartDrawer implementation used by snippets if needed
  window.renderCartDrawer = window.renderCartDrawer || function(panel, cart){
    panel.innerHTML = '';
    const header = document.createElement('div'); header.className = 'cart-drawer__header';
    header.innerHTML = '<div class="cart-drawer__title">Your cart</div><button class="cart-drawer__close" aria-label="Close">✕</button>';
    panel.appendChild(header);
    const list = document.createElement('div'); list.className = 'cart-drawer__list';
    cart.items.forEach(function(line){
      const row = document.createElement('div'); row.className = 'cart-drawer__line';
      let smallImgUrl = line.image;
      if (smallImgUrl) {
        smallImgUrl = smallImgUrl.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_200x$1$2');
      }
      const img = smallImgUrl ? '<img class="cart-drawer__img" src="' + smallImgUrl + '" alt="'+ (line.title || '') +'" loading="lazy">' : '';
      const title = '<div class="cart-drawer__line-title">' + line.title + '</div>';
      const variant = line.variant_title ? '<div class="cart-drawer__variant">'+line.variant_title+'</div>' : '';
      const price = '<div class="cart-drawer__line-price">Rs. ' + ((line.line_price/100).toFixed(2)) + '</div>';
      const qty = '<div class="cart-drawer__qty">' +
                    '<button class="qty-small qty-decrease" data-key="'+line.key+'">−</button>' +
                    '<span class="qty-small-value">'+line.quantity+'</span>' +
                    '<button class="qty-small qty-increase" data-key="'+line.key+'">+</button>' +
                  '</div>';
      const remove = '<button class="cart-drawer__remove" data-key="'+line.key+'" aria-label="Remove">🗑</button>';
      row.innerHTML = '<div class="cart-drawer__line-left">'+img+'</div><div class="cart-drawer__line-mid">'+title+variant+price+'</div><div class="cart-drawer__line-right">'+qty+remove+'</div>';
      list.appendChild(row);
    });
    panel.appendChild(list);
    const footer = document.createElement('div'); footer.className = 'cart-drawer__footer';
    footer.innerHTML = '<div class="cart-drawer__totals"><div class="cart-drawer__totals-label">Estimated total</div><div class="cart-drawer__totals-value">Rs. '+(cart.total_price/100).toFixed(2)+' INR</div></div>' +
                       '<div class="cart-drawer__footer-actions"><a class="cart-drawer__checkout" href="/checkout">CHECK OUT</a></div>';
    panel.appendChild(footer);
    // bind events
    panel.querySelectorAll('.cart-drawer__close').forEach(function(b){ b.addEventListener('click', function(){ document.querySelector('.cart-drawer') && document.querySelector('.cart-drawer').classList.remove('open'); }); });
    panel.querySelectorAll('.qty-small').forEach(function(b){ b.addEventListener('click', function(e){ const key=b.dataset.key; const incr=b.classList.contains('qty-increase')?1:-1; const row=b.closest('.cart-drawer__line'); const val=row.querySelector('.qty-small-value'); let qty=parseInt(val.textContent||'1')+incr; if(qty<0) qty=0; fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(r=>r.json()).then(c=>{ window.renderCartDrawer(panel,c); }); }); });
    panel.querySelectorAll('.cart-drawer__remove').forEach(function(b){ b.addEventListener('click', function(e){ const key=b.dataset.key; fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})}).then(r=>r.json()).then(c=>{ window.renderCartDrawer(panel,c); }); }); });
  }

  // Intercept clicks on cart links using event delegation (capture phase)
  document.addEventListener('click', function(e){
    try{
      // Prefer explicit cart link attribute if present
      var anchor = e.target.closest && (e.target.closest('[data-cart-link]') || e.target.closest('a[href*="/cart"]'));
      if(!anchor) return;
      // Allow user to open in new tab or with modifier keys
      if(e.metaKey || e.ctrlKey || anchor.target === '_blank') return;
      e.preventDefault();
      if(typeof window.openCartDrawer === 'function') window.openCartDrawer();
    }catch(err){
      // ignore
    }
  }, true);

  // Mobile menu toggle (add if you implement mobile menu)
  const menuButton = document.querySelector("[data-menu-toggle]")
  if (menuButton) {
    menuButton.addEventListener("click", () => {
      const menu = document.querySelector("[data-menu]")
      menu?.classList.toggle("hidden")
    })
  }

})
